import React, { useEffect, useRef, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { CModal } from '@coreui/react';
import Swal from 'sweetalert2';
import Select from 'react-select';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import ReactPlayer from 'react-player';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../components/ModalsCommonFunctions';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import Pagination from '../components/Pagination';

const UploadVideoContent = () => {
    const authorizedAxios = generateAxiosInstance()
    const [formData, setFormData] = useState([])
    const initialFormState = {
        // syllabusStructureMasterId: '',
        // subjectMasterId: '',
        gradeMasterIds: [''],
        streamOrMediumMasterId: '',
        boardMasterId: "",
        filePath: '',
        fileName: '',
        description: '',
        title: '',
        tagMasterId: '',
    }
    const [play, setPlay] = useState(false)
    const [PdfBookData, setPdfBookData] = useState(initialFormState)
    const [PdfBookList, setPdfBookList] = useState([])
    const [editId, setEditId] = useState(null)
    const [visible, setVisible] = useState(false)
    const [showPdfLink, setShowPdfLink] = useState("")
    const [tag, setTag] = useState([])
    const [played, setPlayed] = useState(0);
    const playerRef = useRef(null);
    const [volume, setVolume] = useState(0.5);
    const [playbackRate, setPlaybackRate] = useState(1);
    const [isFullScreen, setFullScreen] = useState(false);

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);
    const [addNew, setAddNew] = useState(false);

    const [mediumSort, setMediumSort] = useState(null);
    const [tagSort, setTagSort] = useState(null);
    const [videoNameSort, setVideoNameSort] = useState(null);
    const [videoTitleSort, setVideoTitleSort] = useState(null);
    const [videoDescriptionSort, setVideoDescriptionSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["streamOrMediumMasterDetails.streamName", "tagMasterDetails.tagName", "fileName", "title", "description"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSyllabusStructure();
        getTagMaster();
    }, []);

    const getSyllabusStructure = () => {
        const apiUrl = `/get-data-for-syllabus-structure-master`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setFormData(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getTagMaster = () => {
        const apiUrl = `/get-tag-master`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setTag(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            setRefresh(!refresh);
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const getApiUrl = () => {
        let apiUrl = '/get-video-list?';

        if (PdfBookData.streamOrMediumMasterId !== '') {
            apiUrl += `streamOrMediumMasterId=${PdfBookData.streamOrMediumMasterId}&`;
        }
        if (PdfBookData.boardMasterId !== '') {
            apiUrl += `boardMasterId=${PdfBookData.boardMasterId}&`;
        }
        if (PdfBookData.gradeMasterIds[0] !== '') {
            apiUrl += `gradeMasterIds=${PdfBookData.gradeMasterIds}&`;
        }
        if (PdfBookData.tagMasterId !== '') {
            apiUrl += `tagMasterId=${PdfBookData.tagMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    const getVideoList = () => {
        if (PdfBookData.boardMasterId !== '') {
            authorizedAxios && authorizedAxios.get(getApiUrl())
                .then(response => {
                    setPdfBookList(response.data.result);
                    setAddNew(!addNew);
                })
                .catch(error => {
                    setPdfBookList(error?.response?.data.result);
                    console.error('Error fetching data:', error);
                });
        }
    }

    const handleSearch = async () => {
        if (PdfBookData.boardMasterId !== '') {
            setPdfBookList(await searchArray("A", getApiUrl(), searchKeys, searchValue.trim()))
        }
    }

    useEffect(() => {
        if (PdfBookData.boardMasterId !== '') {
            authorizedAxios && authorizedAxios.get(getApiUrl())
                .then(response => {
                    setPdfBookList(response.data.result);
                })
                .catch(error => {
                    setPdfBookList(error?.response?.data.result);
                    console.error('Error fetching data:', error);
                });
        }
    }, [PdfBookData, refresh]);

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(PdfBookList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId, addNew])

    useEffect(() => {
        setTotalPages(Math.ceil(PdfBookList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > PdfBookList.length) {
            endIndex = PdfBookList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(PdfBookList.slice(startIndex, endIndex));
    }, [PdfBookList, currPage, itemsPerPage]);

    const handleInputChange = (e) => {
        setPdfBookData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const isValidUrl = (url) => {
        const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
        return urlRegex.test(url);
    };

    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)

    const validateForm = () => {
        const errorsValid = Object.values(error).every(error => error === '');

        const pdfBookDataValid = Object.entries(PdfBookData).every(([key, value]) => {
            if (typeof value === 'string') {
                if (value === '' && key !== 'filePath') {
                    return false;
                } else if (key === 'filePath' && value !== '' && !isValidUrl(value)) {
                    return false;
                }
            }
            return true;
        });

        return errorsValid && pdfBookDataValid;
    };

    useEffect(() => {
        if (!Object.values(error).every(error => error === '')) {
            for (const [key, value] of Object.entries(PdfBookData)) {
                if (typeof value === 'string') {
                    if (value === '' || value.length === 0 || (key === 'filePath' && !isValidUrl(value))) {
                        setError(prevData => ({
                            ...prevData,
                            [key]: value === '' ? 'This field is required.' : 'Invalid URL'
                        }));
                    } else {
                        setError(prevData => ({
                            ...prevData,
                            [key]: ''
                        }));
                    }
                }
            }
        }
    }, [PdfBookData]);

    const addLesson = async () => {
        const apiUrl = `/add-video`;
        if (validateForm()) {
            try {
                setLoading(true);
                const response = await authorizedAxios.post(apiUrl, PdfBookData);
                getVideoList();
                setPdfBookData(prevData => ({
                    ...prevData,
                    filePath: '',
                    fileName: '',
                    title: '',
                    description: '',
                    url: '',
                }));

                setSaveId(response.data.result.id);
                setMediumSort(null);
                setTagSort(null);
                setVideoNameSort(null);
                setVideoTitleSort(null);
                setVideoDescriptionSort(null);
                Swal.fire({ text: response.data.message });
            } catch (error) {
                const errorMsg = error?.data?.message || 'Something went wrong!';
                Swal.fire({ text: errorMsg });
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(PdfBookData)) {
                if (value === '' || value.length === 0) {
                    setError(prevData => ({
                        ...prevData,
                        [key]: 'This field is required.',
                    }));
                } else {
                    setError(prevData => ({
                        ...prevData,
                        [key]: '',
                    }));
                }
            }

            if (!isValidUrl(PdfBookData.filePath)) {
                setError(prevData => ({
                    ...prevData,
                    filePath: 'Invalid URL',
                }));
            }
        }
    };

    const deleteLesson = (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/delete-video?id=${id}`;
            authorizedAxios && authorizedAxios.delete(apiUrl)
                .then(response => {
                    const page = deleteItem(currPage, itemsPerPage, PdfBookList.length);
                    setRefresh(!refresh);
                    setCurrPage(page);
                    // setPdfBookList((prevLessonList) => [...prevLessonList].filter((lesson) => lesson.id !== id))
                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        }
    }

    const handleSeekChange = (e) => {
        const seekValue = parseFloat(e.target.value);
        setPlayed(seekValue);
        playerRef.current.seekTo(seekValue, 'fraction');
    };

    const handleProgress = (progress) => {
        setPlayed(progress.played);
    };

    const handleVolumeChange = (e) => {
        setVolume(parseFloat(e.target.value));
    };

    const handleSpeedChange = (e) => {
        setPlaybackRate(parseFloat(e.target.value));
    };

    const ClassList = formData?.gradeData?.map((sub) => {
        return {
            value: sub.id,
            label: sub.gradeName
        }
    }) || [];

    const handleChangeBoard = (selectedOptions) => {
        const selectedIds = selectedOptions.map((option) => option.value.toString());
        setPdfBookData((prevData) => {
            return {
                ...prevData,
                gradeMasterIds: selectedIds,
            }
        })
    }

    useEffect(() => {
        if (mediumSort == true || mediumSort == false) {
            setTagSort(null);
            setVideoNameSort(null);
            setVideoTitleSort(null);
            setVideoDescriptionSort(null);
        }
    }, [mediumSort])

    useEffect(() => {
        if (tagSort == true || tagSort == false) {
            setMediumSort(null);
            setVideoNameSort(null);
            setVideoTitleSort(null);
            setVideoDescriptionSort(null);
        }
    }, [tagSort])

    useEffect(() => {
        if (videoNameSort == true || videoNameSort == false) {
            setMediumSort(null);
            setTagSort(null);
            setVideoTitleSort(null);
            setVideoDescriptionSort(null);
        }
    }, [videoNameSort])

    useEffect(() => {
        if (videoTitleSort == true || videoTitleSort == false) {
            setMediumSort(null);
            setTagSort(null);
            setVideoNameSort(null);
            setVideoDescriptionSort(null);
        }
    }, [videoTitleSort])

    useEffect(() => {
        if (videoDescriptionSort == true || videoDescriptionSort == false) {
            setMediumSort(null);
            setTagSort(null);
            setVideoNameSort(null);
            setVideoTitleSort(null);
        }
    }, [videoDescriptionSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Video Content Upload</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-cloud-arrow-up"></i>Video Content Upload </b></h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Board :</label>
                                                    <select class="form-select" disabled={editId} aria-label="Default select example" name='boardMasterId' onChange={handleInputChange} value={PdfBookData.boardMasterId}>
                                                        <option selected value={''} disabled>Select Board</option>
                                                        {
                                                            formData?.boardData?.map((board) => {
                                                                return <option value={board.id}>{board.boardName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.boardMasterId && <p style={{ color: 'red' }}>{error.boardMasterId}</p>}

                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Medium :</label>
                                                    <select class="form-select" disabled={editId} aria-label="Default select example" name='streamOrMediumMasterId' onChange={handleInputChange} value={PdfBookData.streamOrMediumMasterId}>
                                                        <option selected value={''} disabled>Select Medium</option>
                                                        {
                                                            formData?.streamOrMediumData?.map((stream) => {
                                                                return <option value={stream.id}>{stream.streamName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.streamOrMediumMasterId && <p style={{ color: 'red' }}>{error.streamOrMediumMasterId}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <Select
                                                        value={ClassList.filter(option =>
                                                            PdfBookData.gradeMasterIds && PdfBookData.gradeMasterIds.includes(option.value.toString())
                                                        )}
                                                        isMulti
                                                        name="gradeMasterIds"
                                                        options={ClassList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleChangeBoard}
                                                    />
                                                    {error.gradeMasterIds && <p style={{ color: 'red' }}>{error.gradeMasterIds}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Tag :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='tagMasterId' onChange={handleInputChange} value={PdfBookData.tagMasterId}>
                                                        <option selected value={''} disabled>Select Tag</option>
                                                        {
                                                            tag?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.tagName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.tagMasterId && <p style={{ color: 'red' }}>{error.tagMasterId}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>File Name:</label>
                                                    <input required type="text" className="form-control" name="fileName" value={PdfBookData.fileName} onChange={handleInputChange} />
                                                    {error.fileName && <p style={{ color: 'red' }}>{error.fileName}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Video Url:</label>
                                                    <input required type="text" className="form-control" name="filePath" value={PdfBookData.filePath} onChange={handleInputChange} />
                                                    {error.filePath && <p style={{ color: 'red' }}>{error.filePath}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Title:</label>
                                                    <input required type="text" className="form-control" name="title" value={PdfBookData.title} onChange={handleInputChange} />
                                                    {error.title && <p style={{ color: 'red' }}>{error.title}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Description:</label>
                                                    <input required type="text" className="form-control" name="description" value={PdfBookData.description} onChange={handleInputChange} />
                                                    {error.description && <p style={{ color: 'red' }}>{error.description}</p>}
                                                </div>

                                            </div>
                                            <CModal
                                                backdrop="static"
                                                visible={visible}
                                                onClose={() => setVisible(false)}
                                                aria-labelledby="LiveDemoExampleLabel"
                                                className={isFullScreen ? "full_scr_view" : ""}
                                            >
                                                <button className="close-button video-close" onClick={() => setVisible(false)}><i class="fa fa-window-close fa-2xl" aria-hidden="true"></i></button>
                                                <div className="test test-player">
                                                    <ReactPlayer
                                                        ref={playerRef}
                                                        url={showPdfLink}
                                                        playing={play}
                                                        volume={volume}
                                                        onProgress={handleProgress}
                                                        playbackRate={playbackRate}
                                                    >
                                                    </ReactPlayer>
                                                    <div className="overlay-layer">
                                                        <div className="trigger" onClick={() => setPlay(!play)} >Play</div>
                                                    </div>
                                                </div>
                                                <div className="video_content_bottom">
                                                    <div className="video_progress">
                                                        <input
                                                            type="range"
                                                            min={0}
                                                            max={1}
                                                            step="any"
                                                            value={played}
                                                            onChange={handleSeekChange}
                                                            className="input_slider"
                                                        />
                                                    </div>

                                                    <div className='play_pause_sound'>
                                                        <div className='sound'>
                                                            {!play ? <button onClick={() => setPlay(true)} className="play_pause_btn"> <i class="fa fa-play"></i></button> :
                                                                <button onClick={() => setPlay(false)} className="play_pause_btn"><i class="fa fa-pause"></i></button>}

                                                            {volume >= 0.5 && <button className='play_pause_btn'>
                                                                <i class="fa fa-volume-high"></i>
                                                            </button>}
                                                            {volume < 0.5 && volume > 0 && <button className='play_pause_btn'>
                                                                <i class="fa fa-volume-low"></i>
                                                            </button>}
                                                            {volume == 0 && <button className='play_pause_btn'>
                                                                <i class="fa fa-volume-xmark"></i>
                                                            </button>}

                                                            <div className='sound_bar'>
                                                                <input
                                                                    type="range"
                                                                    value={volume}
                                                                    onChange={handleVolumeChange}
                                                                    min="0"
                                                                    max="1"
                                                                    step="0.01"
                                                                    className="input_slider"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className='playbeack_speed'>
                                                            <span>Playback speed</span>
                                                            <select onClick={handleSpeedChange}>
                                                                <option value={0.25}>0.25</option>
                                                                <option value={0.5}>0.5</option>
                                                                <option value={0.75}>0.75</option>
                                                                <option selected value={1}>Normal</option>
                                                                <option value={1.25}>1.25</option>
                                                                <option value={1.5}>1.5</option>
                                                                <option value={1.75}>1.75</option>
                                                            </select>
                                                        </div>
                                                        <div className='fullscreen_mode'>
                                                            <button className='full_scr_btn' onClick={() => setFullScreen(!isFullScreen)}>{isFullScreen ? <i className="fa fa-compress"></i> : <i className="fa fa-expand"></i>}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CModal>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addLesson}>Save</button>
                                                        }
                                                        <button className="btn btn-outline-danger delete_icon" type="reset" style={{ marginRight: '20px' }} onClick={() => { setPdfBookList([]); setEditId(''); setPdfBookData(initialFormState) }}>Reset</button>
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table-width">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div className="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">Board</th>
                                                                        <th scope="col">
                                                                            Medium
                                                                            <SortIcon sortState={mediumSort} setSortState={setMediumSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"streamOrMediumMasterDetails.streamName"} />
                                                                        </th>
                                                                        <th scope="col">Class</th>
                                                                        <th scope="col">
                                                                            Tag Name
                                                                            <SortIcon sortState={tagSort} setSortState={setTagSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"tagMasterDetails.tagName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Video Name
                                                                            <SortIcon sortState={videoNameSort} setSortState={setVideoNameSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"fileName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Video Title
                                                                            <SortIcon sortState={videoTitleSort} setSortState={setVideoTitleSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"title"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Video Description
                                                                            <SortIcon sortState={videoDescriptionSort} setSortState={setVideoDescriptionSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"description"} />
                                                                        </th>
                                                                        <th scope="col">Video</th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((lesson, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{lesson?.boardMasterDetails?.boardName}</td>
                                                                                        <td>{lesson?.streamOrMediumMasterDetails?.streamName}</td>
                                                                                        <td>{lesson?.videoMasterDetails?.map(grades => grades.gradeMasterDetails.gradeName).join(", ")}</td>
                                                                                        <td>{lesson?.tagMasterDetails?.tagName}</td>
                                                                                        <td>{lesson.fileName}</td>
                                                                                        <td>{lesson.title}</td>
                                                                                        <td>{lesson.description}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                setShowPdfLink(lesson.filePath)
                                                                                                setVisible(true)
                                                                                            }}><i class="fa fa-eye" ></i></button>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => deleteLesson(lesson.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Video Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={PdfBookList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default UploadVideoContent;